export default "Error in new.cr:5: expanding macro\n\nnew BadType\n^~~\n\nin new.cr:5: undefined constant BadType\n\nnew BadType\n    ^~~~~~~\n";